exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check[data-v-7f3cc7aa] {\n  margin-bottom: 0.2rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #bfc2ce;\n  border: 2px solid #ffffff00;\n}\n.form-check.selected[data-v-7f3cc7aa] {\n  color: white;\n}", ""]);

// exports
